import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  saveClient,
  deleteClient
} from '../../actions/advisor';
import {
  NF_TEST,
  LA_TEST,
  RR_TEST,
} from '../../constants.js';
import s from './EditClientForm.css';

class EditClientForm extends PureComponent {

  constructor(props) {
    super(props);
    const newClient = {
      id: props.client.id,
      advisorEmail: props.client.advisorEmail,
      firstName: props.client.firstName,
      lastName: props.client.lastName,
      email: props.client.email,
      tests: props.client.tests,
    };
    this.state = {
      client: newClient,
      deleteButton: 'DELETE',
    };
  }

  // update the value to state for form text fields
  editClientFormChange = (event) => {
    const target = event.target;
    const {
      name,
      value,
     } = target;
    const newClient = Object.assign({}, this.state.client);
    newClient[name] = value;
    this.setState(Object.assign({}, this.state, {
      client: newClient,
    }));
  }

  // add/remove tests from the state tests array
  toggleSelectedTests(event, name) {
    event.preventDefault();
    const newClient = Object.assign({}, this.state.client);
    const uTests = Object.assign([], newClient.tests);
    const index = uTests.indexOf(name);
    if (index === -1) {
      uTests.push(name);
    } else {
      uTests.splice(index, 1);
    }
    newClient.tests = uTests;
    this.setState(Object.assign({}, this.state, {
      client: newClient,
    }));
  }

  checkIfCompleted(name) {
    const completed = this.props.client.results.filter((result) => result.name === name);
    return completed.length > 0 ? true : false;
  }

  // save client with current saved state values
  saveClient = (event) => {
    const {
      client,
    } = this.state;
    event.preventDefault();
    if(client.firstName !== '' && client.lastName !== '' && client.email !== '') {
      this.props.saveClient(client);
    }
  }

  // delete the client
  deleteClient = (event) => {
    event.preventDefault();
    if(this.state.deleteButton === 'DELETE') {
      this.setState(Object.assign({}, this.state, {
        deleteButton: 'CONFIRM',
      }));
    } else {
      this.props.deleteClient(this.state.client);
      this.setState(Object.assign({}, this.state, {
        deleteButton: '...',
      }));
    }
  }

  // render out the select tool buttons with on/off css state
  renderToolButton(name) {
    let title = '';
    switch(name) {
      case NF_TEST:
        title = 'Big Picture Assessment';
        break;
      case LA_TEST:
        title = 'Loss Aversion';
        break;
      case RR_TEST:
        title = 'Retirement Regret';
        break;
      default:
        break;
    }
    const completed = this.checkIfCompleted(name);
    if (this.state.client.tests.includes(name)) {
      return (
        <button
          onClick={(event) => this.toggleSelectedTests(event, name)}
          className={s.toolButton + ' ' + (completed ? s.toolButtonOnComplete : s.toolButtonOn)}
        >{title}</button>
      );
    } else {
      return (
        <button
          onClick={(event) => this.toggleSelectedTests(event, name)}
          className={s.toolButton + ' ' + s.toolButtonOff}
        >{title}</button>
      );
    }
  }

  render() {
    const {
      client,
      deleteButton,
    } = this.state;
    return (
      <div>
        <form>
          <div className={'row'}> {/*(this.props.index === 0 ? s.bgOn : '') + */}
            <div className="col-md-10">
              <div className={'form-group row'}>
                <div className="col-md-4">
                  <input
                    name="firstName"
                    value={client.firstName}
                    onChange={this.editClientFormChange}
                    type="text"
                    className={s.formFieldText + ' form-control'} placeholder="First Name"
                  />
                </div>
                <div className="col-md-4">
                  <input
                    name="lastName"
                    value={client.lastName}
                    onChange={this.editClientFormChange}
                    type="text"
                    className={s.formFieldText + ' form-control'}
                    placeholder="Last Name"
                  />
                  </div>
                <div className="col-md-4">
                  <input
                    name="email"
                    value={client.email}
                    onChange={this.editClientFormChange}
                    type="text"
                    className={s.formFieldText + ' form-control'} placeholder="Email"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <button
                onClick={this.saveClient}
                className={s.addClientButton}
              >SAVE</button>
            </div>
          </div>
          <div className={'row'}>
            <div className="col-md-10">
              <div className={'form-group row'}>
                <div className="col-md-4">
                  {this.renderToolButton(NF_TEST)}
                </div>
                <div className="col-md-4">
                  {this.renderToolButton(LA_TEST)}
                </div>
                <div className="col-md-4">
                  {this.renderToolButton(RR_TEST)}
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <button
                onClick={this.deleteClient}
                className={s.deleteClientButton}
              >{deleteButton}</button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {
  saveClient,
  deleteClient,
})(EditClientForm);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/EditClientForm.js